import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Popover, Typography, Box, Button } from "@mui/material";
import CircularProgress from "@material-ui/core/CircularProgress";
import { requestPermisisonServices } from "services/project";
import {
  SnackbarEmitter,
  DEFAULT_MESSAGE,
  SNACKBAR_VARIANT,
} from "constants/snackbarController";
import { get } from "lodash";
import "./index.scss";
import { useTranslation } from "react-i18next";

const RequestPermission = ({ open, anchorEl, projectId, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const onRequestPermisison = useCallback(async () => {
    try {
      setLoading(true);
      const result = await requestPermisisonServices(projectId);
      if (result?.data?.state) {
        SnackbarEmitter(
          SNACKBAR_VARIANT.SUCCESS,
          DEFAULT_MESSAGE.MUTATE.SUCCESS
        );
      } else {
        SnackbarEmitter(
          SNACKBAR_VARIANT.ERROR,
          get(result, "msg", DEFAULT_MESSAGE.MUTATE.ERROR)
        );
      }
    } catch (err) {
      SnackbarEmitter(
        SNACKBAR_VARIANT.ERROR,
        get(err, "message", DEFAULT_MESSAGE.MUTATE.ERROR)
      );
    } finally {
      setLoading(false);
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  return (
    <Popover
      id={"request-permission"}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      className="request-permission-popover"
    >
      <Box className="request-permission-popover__content">
        <Box style={{ paddingRight: 32 }}>
          <Typography>
            {t("REQUEST_PROJECT.TEXT1")}{" "}
            <strong>{t("REQUEST_PROJECT.VIEW")}</strong>{" "}
            {t("REQUEST_PROJECT.TEXT2")}.
          </Typography>
          <Typography>{t("REQUEST_PROJECT.DES")}.</Typography>
        </Box>
        <Button
          variant="container"
          className="request-permission-popover__btn-request"
          onClick={onRequestPermisison}
          loading={loading}
        >
          {loading && (
            <CircularProgress
              size={12}
              color="white"
              style={{ marginRight: "8px" }}
            />
          )}
          {t("REQUEST_PROJECT.BTN")}
        </Button>
      </Box>
    </Popover>
  );
};

RequestPermission.propTypes = {
  open: PropTypes.bool,
  anchorEl: PropTypes.any,
  handleClose: PropTypes.func,
};

export default RequestPermission;
